import { IHoanPhiCalculateRequest } from "../models/request/hoan-phi/HoanPhiCalculateRequest";
import { apiClient } from "./apiClient";

export const hoanPhiApi = {
    calculate: (data: IHoanPhiCalculateRequest) => apiClient.post(`hoan-phi/calculate`, data)
}